import React from 'react';
import ExifReader from 'exifreader/dist/exif-reader';

import { AddPhotoError } from '../../../PhotoUpload/AddPhoto';
import Img from '../../../Img';

import styles from './addPhoto.scss';
import { getClickAttrs } from '../../../Analytics/gtag';

const validTypes = ['image/jpeg', 'image/png', 'image/gif'];

const p = require('pica/dist/pica')();

class AddPhotoV3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadError: null,
        };
        this.handleUploadImage = this.handleUploadImage.bind(this);
        this.handleCloseError = this.handleCloseError.bind(this);
        this.handleRemovePhoto = this.handleRemovePhoto.bind(this);
    }

    handleCloseError() {
        this.setState({ loadError: null });
    }

    handleUploadImage(ev) {
        ev.preventDefault();
        const imageFile = ev.target.files[0];

        // verify image type as correct
        if (!validTypes.includes(imageFile.type)) {
            this.setState({ loadError: 'Invalid file type. Accepted formats are Jpeg, Png, and Gif' });
            return;
        }
        this.props.uploadStart();
        const $this = this;
        $this.orientation = null;
        const img = new Image();
        img.onload = (e) => {
            const loadedImage = e.target;
            const canvas = window.document.createElement('canvas');
            canvas.width = loadedImage.width;
            canvas.height = loadedImage.height;
            const maxWidth = $this.props.maxSize || 1024;
            const maxHeight = $this.props.maxSize || 1024;
            // restrict image to max bounds
            if (loadedImage.width > maxWidth) {
                canvas.width = maxWidth;
                canvas.height = loadedImage.height * maxWidth / loadedImage.width;
            }
            if (canvas.height > maxHeight) {
                canvas.height = maxHeight;
                canvas.width = loadedImage.width * maxHeight / loadedImage.height;
            }
            if (canvas.width !== loadedImage.width || canvas.height !== loadedImage.height) {
                p.resize(loadedImage, canvas, {
                    unsharpAmount: 80,
                    unsharpRadius: 0.6,
                    unsharpThreshold: 2,
                })
                    .then(result => p.toBlob(result, imageFile.type))
                    .then(blob => $this.props.uploadPhoto(
                        {
                            file: blob,
                            orientation: $this.orientation,
                            extension: imageFile.name.substr(imageFile.name.lastIndexOf('.')),
                        },
                    ))
                    .catch(error => {
                        console.log('ERROR', error);
                        $this.setState( // TODO: clear url
                            { loadError: 'There was a problem processing your file, make sure it is under 10 Mb and is Jpeg, Png, or Gif format' },
                        );
                    });
            } else {
                $this.props.uploadPhoto({
                    file: imageFile,
                    orientation: $this.orientation,
                    extension: imageFile.name.substr(imageFile.name.lastIndexOf('.')),
                });
            }
        };
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
            try {
                // parse out the exif orientation
                const tags = ExifReader.load(readerEvent.target.result, { expanded: true });
                $this.orientation = tags.exif.Orientation.value;
            } catch (error) {
                console.log(error);
            }
            img.src = window.URL.createObjectURL(imageFile);
        };
        reader.readAsArrayBuffer(imageFile);
        ev.target.value = '';
    }

    handleRemovePhoto() {
        this.props.removePhoto();
    }

    render() {
        const { hasProfileImage, 'data-testid': dataTestId } = this.props;
        return (
            <div className={styles.buttonWrapper} data-testid={dataTestId}>
                <label
                    className={styles.editBtn}
                    {...getClickAttrs({
                        category: 'Profile Edit',
                        context: `Player profile photo upload`,
                        location: 'Profile Header - Avatar',
                    })}
                    data-testid={dataTestId ? `${dataTestId}.edit-btn` : undefined}
                >
                    <Img src={'/img/v3/icons/icon-24px-pen.svg'} />
                    <input onChange={this.handleUploadImage} type="file" accept="image/png,image/jpeg,image/gif" data-testid={dataTestId ? `${dataTestId}.file-input` : undefined} />
                </label>
                {hasProfileImage && (
                    <div
                        className={styles.deleteBtn}
                        onClick={this.handleRemovePhoto}
                        {...getClickAttrs({
                            category: 'Profile Edit',
                            context: `Remove Player profile photo`,
                            location: 'Profile Header - Avatar',
                        })}
                        data-testid={dataTestId ? `${dataTestId}.delete-btn` : undefined}
                    >
                        <Img src={'/img/v3/icons/icon-24px-trash.svg'} />
                    </div>
                )}
                <AddPhotoError loadError={this.state.loadError} closeError={this.handleCloseError} />
            </div>
        );
    }
}

export default AddPhotoV3;
